import BasePage from "../../../base/BasePage";
import React from "react";
import { addSchemaUseCase } from "../../../usecases/schema/usecases";
import AccomplishmentPresenter from "./AccomplishmentPresenter";
import CardView from "../../../components/common/CardView";
import RegionTab from "../../../components/common/RegionTab";
import AccomplishmentReport from "./AccomplishmentsTable/AccomplishmentReport";
import AccomplishmentList from "./AccomplishmentsTable/AccomplishmentList";
import OpenForNominationTable from "../Nomination/UserNominationTable/OpenForNominationTable";
import UserAccomplishments from "./UserAccomplishmentsTable/UserAccomplishments";
import UserRecommendations from "./UserAccomplishmentsTable/UserRecommendations";

class AccomplishmentPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new AccomplishmentPresenter(this, addSchemaUseCase());
    this.state = {
      progress: false,
    };
  }

  componentDidMount() {
    const roles = this.getCurrentRoles();
    console.log("roles", roles);
    if (roles.some((item) => item.id === "user")) {
      this.setState({ isUser: true });
    } else {
      this.setState({ isUser: false });
    }
  }

  render() {
    const tabs = [
      { title: "Accomplishment Reports", content: <AccomplishmentReport /> },
      { title: "List of Employees", content: <AccomplishmentList /> },
    ];

    const userTabs = [
      { title: "Accomplishment", content: <UserAccomplishments /> },
      { title: "Recommendation", content: <UserRecommendations /> },
    ];
    const userTabContents = userTabs.map((tab) => tab.content);

    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Merit Reward and Recognition &gt;{" "}
              <span style={{ color: "#333" }}>Accomplishments</span>
            </p>
          </div>
          {this.state.isUser ? (
            <RegionTab tabs={userTabs} tabContents={userTabContents} />
          ) : (
            <RegionTab tabs={tabs} tabContents={tabContents} />
          )}
        </div>
      </>
    );
  }
}

export default AccomplishmentPage;
